import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './pages/home/home.component';
import { CoreModule } from 'app/core/core.module';
import { HomeButtonComponent } from './components/home-button/home-button.component';
import { TransportChartComponent } from './components/transport-chart/transport-chart.component';
import { ChartsModule } from 'ng2-charts';
import { MaterialChartComponent } from './components/material-chart/material-chart.component';
import { DangerousMaterialComponent } from './components/dangerous-material/dangerous-material.component';
import { ContractChartComponent } from './components/contract-chart/contract-chart.component';

@NgModule({
  imports: [
    HomeRoutingModule,
    CommonModule,
    CoreModule,
    ChartsModule
  ],
  declarations: [
    HomeComponent,
    HomeButtonComponent,
    TransportChartComponent,
    MaterialChartComponent,
    DangerousMaterialComponent,
    ContractChartComponent
  ]
})
export class HomeModule { }
